import { render } from "./Prc.vue?vue&type=template&id=dea88fc2&scoped=true"
import script from "./Prc.vue?vue&type=script&lang=js"
export * from "./Prc.vue?vue&type=script&lang=js"

import "./Prc.vue?vue&type=style&index=0&id=dea88fc2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/lemmi_front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dea88fc2"]])

export default __exports__